<template>
  <div class="container" style="margin-top: 90px;">
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="row">
          <div class="col-12 text-center">
            <img class="w-100" src="../assets/Admin_Portal_Icon.jpg" />
          </div>
          <div class="col-3"></div>
          <div class="col-6" v-if="passwordReset == false">
            <div>
              <Alert
                v-if="errorMessage.length > 0"
                :message="errorMessage"
                :error="true"
              />
              <Alert
                v-if="successMessage.length > 0"
                :message="successMessage"
                :error="false"
              />
              <form
                style="margin-top: 35px;"
                class="user"
                v-on:submit.prevent="login"
              >
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control mb-3"
                    v-model="email"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    v-model="password"
                    placeholder="Enter your password"
                  />
                </div>
                <div class="row">
                  <div class="col-12">
                    <button
                      type="submit"
                      class="btn btn-primary btn-user btn-block mt-4"
                    >
                      Login
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="text-center">
              <button
                @click="toggleReset()"
                class="transparent-button forgot-password-btn mt-2"
              >
                Forgot Password?
              </button>
            </div>
            <hr />
            <div class="row text-center">
              <div class="col-12">
                Don't have an account ? <a href="/sign-up"><b>Sign Up</b></a>
              </div>
            </div>
          </div>
          <div class="col-6" style="margin-top: 35px;" v-else>
            <div class="text-center">
              <label style="font-size: 18px;">Enter your email address</label>
              <input
                type="text"
                class="form-control my-3"
                v-model="resetEmail"
                placeholder="Enter your email address"
              />

              <button
                @click="resetPassword"
                class="btn btn-primary btn-user btn-block mt-4"
              >
                Reset
              </button>
              <button
                @click="toggleReset()"
                class="transparent-button forgot-password-btn"
              >
                Back to Login
              </button>
            </div>
          </div>
          <div class="col-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../controllers/user.controller";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      resetEmail: "",
      errorMessage: "",
      passwordReset: false,
      successMessage: "",
    };
  },
  methods: {
    toggleReset() {
      this.passwordReset = !this.passwordReset;
      this.successMessage = "";
      this.errorMessage = "";
    },

    login() {
      this.errorMessage = "";
      if (this.email == "" || this.password == "") {
        this.errorMessage = "Please fill in both the email and password fields";
        return false;
      }

      // Remove any white spaces from the input
      this.email = this.email.replace(/\s+/g, "");
      this.password = this.password.replace(/\s+/g, "");

      User.authenticate(this.email, this.password)
        .then(() => {
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          this.errorMessage = error.message || error.Error;
        });
    },

    async resetPassword() {
      this.errorMessage = "";
      if (!this.resetEmail) {
        this.errorMessage = "Please provide a valid email address";
        return;
      }

      let sent = await User.resetPassword(this.resetEmail);

      if (sent == true) {
        this.successMessage = "An email with instructions has been sent to you";
      } else if (sent.error) {
        this.errorMessage = sent.error;
      } else {
        this.errorMessage = "Something went wrong with resetting your email";
        return;
      }
    },
  },
};
</script>
